import config from './config'
import IndicadoresModules from './ind'
// import Accreditation from '../views/app/config/Accreditation.vue'
import SwotAnalysis from '../views/app/swot/SwotAnalysis.vue'
import FactorManagement from '../views/app/swot/FactorManagement.vue'

export default [
    {
        path: '/',
        component: () => import("../views/app/Inicio.vue")
    },
    {
        path: 'indicadores',
        component: () => import("../views/app/indicadores/Index.vue"),
        children: IndicadoresModules
    },
    {
        path: 'evaluar',
        component: () => import("../views/app/evaluation/Index.vue"),
        children: IndicadoresModules
    },
    {
        path: 'acuerdos',
        component: () => import("../views/app/acuerdos/Index.vue"),
        children: IndicadoresModules
    },
    {
        path: 'reportes',
        component: () => import("../views/app/Reportes.vue"),
        children: IndicadoresModules
    },
    {
        path: 'reportes-unidades',
        component: () => import("../views/app/Reportes_Unidades.vue"),
        children: IndicadoresModules
    },
    {
        path: 'riesgo',
        component: () => import("../views/app/risk/Index.vue"),
    },
    {
        path: 'ose',
        component: () => import("../views/app/ose/Index.vue"),
    },
    {
        path: 'avances',
        component: () => import("../views/app/indicadores/ProgressReport.vue"),
        children: IndicadoresModules
    },
    {
        // Relatório de PDCA por setor e situação do plano de ação (baseado no relatório de avanços)
        path: 'relatorio-pdca',
        component: () => import("../views/app/indicadores/PdcaReport.vue"),
    },
    {
        // Relatório de indicadores por KPI Template (estratégico / por template)
        path: 'relatorio-kpi-template',
        component: () => import("../views/app/indicadores/RelatorioKpiTemplate.vue"),
    },
    // {
    //     path: 'avances-todos',
    //     component: () => import("../views/app/config/UsersCreateAssessor.vue"),
    //     children: IndicadoresModules
    // },
    {
        path: 'checklist',
        component: () => import("../views/app/checklist/IndexChecklist.vue"),
    },
    {
        path: 'kpi',
        component: () => import("../views/app/kpi/Index.vue"),
    },
    {
        path: 'kpi-manager',
        component: () => import("../views/app/analysis/AnalysisIndex.vue"),
    },
    {
        path: 'kpi-analysis',
        component: () => import("../views/app/analysis/AnalysisIndex.vue"),
    },
    {
        path: 'feedback',
        component: () => import("../views/app/feedback/Init.vue"),
    },
    {
        path: 'indicadores-stereotype',
        component: () => import("../views/app/manager/Index.vue"),
    },
    /*{
        path: 'kpi-manager',
        component: () => import("../views/app/manager/operative/Index.vue"),
    },*/
    {
        path: 'ceo',
        component: () => import("../views/app/ceo/Index.vue"),
    },
    {
        path: 'map',
        component: () => import("../views/app/map/Index.vue"),
    },
    {
        path: 'env',
        component: () => import("../views/app/Entorno.vue"),
        children: IndicadoresModules
    },
    {
        path: 'configuraciones',
        component: () => import("../views/app/config/Index.vue"),
        //children: config
    },
    
    {
        path: 'configuraciones/usuario',
        component: () => import("../views/app/config/Users.vue"),
        //children: config
    },
    {
        // Gestão de usuários restrita à unidade hospitalar do usuário logado.
        // Usa endpoint: GET /user/company/{companyId}/by-hospital-unit/user-company/{userCompanyId}
        // Papéis disponíveis: Colaborador (2), Auditor (3), Assessor (4), Gestão de Controle (7)
        // Setores disponíveis: setor do usuário logado + toda a hierarquia descendente
        path: 'configuraciones/unidade-users',
        component: () => import("../views/app/config/HospitalUnitUsers.vue"),
    },
    { path:'configuraciones/indicadores', component: ()=>import("../views/app/config/Kpi.vue")},
    {
        path: 'configuraciones/periodo',
        component: () => import("../views/app/config/Periodo.vue"),
        //children: config
    },
    {
        path: 'configurar-periodos',
        component: () => import("../views/app/config/ConfigurarPeriodos.vue"),
    },
    
    {
        path: 'configuraciones/grupo',
        component: () => import("../views/app/config/Grupos.vue"),
        //children: config
    },
    {
        path: 'configuraciones/acreditations',
        component: () => import("../views/app/config/Accreditation.vue"),
        //children: config
    },
    {
        path: 'configuraciones/leadership',
        component: () => import("../views/app/config/Leadership.vue"),
        //children: config
    },
    {
        path: 'configuraciones/mail',
        component: () => import("../views/app/config/Email.vue")
    },
    {
        path: 'configuraciones/plan',
        component: () => import("../views/app/config/Plan.vue")
    },
    {
        path: 'configuraciones/stereotype',
        component: () => import("../views/app/config/Stereotype.vue")
    },
    {
        path: 'configuraciones/sector',
        component: () => import("../views/app/config/Sector.vue")
    },
    {
        path: 'configuraciones/integration',
        component: () => import("../views/app/config/Integration.vue")
    },
    {
        path: 'configuraciones/tipo-sector',
        component: () => import("../views/app/config/SectorType.vue")
    },
    {
        path: 'configuraciones/tipo-objetivo',
        component: () => import("../views/app/config/ObjectiveType.vue")
    },
    {
        path: 'configuraciones/load-data',
        component: () => import("../views/app/config/CalcularSector.vue")
    },
    {
        path: 'configuraciones/cal-objetivo',
        component: () => import("../views/app/config/Category.vue")
    },
    {
        path: 'configuraciones/cal-sector',
        component: () => import("../views/app/config/Grade.vue")
    },
    {
        path: 'configuraciones/admin-data',
        component: () => import("../views/app/indicadores/Admin.vue")
    },
    {
        path: 'configuraciones/block',
        component: () => import("../views/app/config/Block.vue")
    },
    {
        path: 'configuraciones/kpi-template',
        component: () => import("../views/app/config/KpiTemplate.vue")
    },
    {
        path: 'configuraciones/modules',
        component: () => import("../views/app/config/AccessManager.vue")
    },
    {
        path: 'configuraciones/roles-access',
        component: () => import("../views/app/config/AccessRoleManager.vue")
    },
    { 
        path: 'configuraciones/sectors-access',
        component: () => import("../views/app/config/AccessSectorManager.vue")
    },
    {
        path: 'process',
        component: () => import("../views/app/process/Index.vue")
    },
    {
        path: 'epr',
        component: () => import("../views/app/epr/Index.vue")
    },
    {
        path: '/swot',
        name: 'swot',
        component: SwotAnalysis,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/swot/factors',
        name: 'factor-management',
        component: FactorManagement,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/swot/initiative',
        name: 'initiative-management',
        component: () => import("../views/app/swot/InitiativeManagement.vue"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/swot/objectives',
        name: 'objective-management',
        component: () => import("../views/app/swot/ObjectiveManagement.vue"),
        meta: {
            requiresAuth: true
        }
    },
    // {
    //     path: '/config/users',
    //     name: 'users',
    //     component: Assessment,
    //     meta: {
    //         requiresAuth: true
    //     }
    // },
    {
        path: '/swot/menu',
        name: 'swot-menu',
        component: () => import("../views/app/swot/Menu.vue"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/swot/cross',
        name: 'swot-cross',
        component: () => import("../views/app/swotCross/SwotCross.vue"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '*',
        component: () => import("../views/app/Inicio.vue")
    }
    
]